import { extend } from 'flarum/common/extend';
function disableInputs(vnode) {
  if (!vnode || typeof vnode !== 'object') return;
  if (vnode.tag === 'input') vnode.attrs = {
    ...vnode.attrs,
    disabled: true
  };
  for (const child of vnode.children || []) disableInputs(child);
}
export default function editUserIdentity() {
  extend('flarum/common/components/EditUserModal', 'fields', function (items) {
    if (items.has('email')) disableInputs(items.get('email'));
  });
  extend('flarum/common/components/EditUserModal', 'data', function (data) {
    // The shared admin/forum modal must submit group changes without an email
    // update: all identity information is managed by HUSTAB ID.
    delete data.email;
  });
}
flarum.reg.add('hustab-space', 'editUserIdentity', editUserIdentity);